unable to read source [project]/packages/app/node_modules/superstruct/src/struct.ts